export default {
  computed: {
    $bookingNotes () {
      return this.$store.state.NoteStore.all_notes
    }
  }
}
